import { render } from "./ComparativeProfitAndLossList.vue?vue&type=template&id=1b293c1c"
import script from "./ComparativeProfitAndLossList.vue?vue&type=script&lang=js"
export * from "./ComparativeProfitAndLossList.vue?vue&type=script&lang=js"

import "./ComparativeProfitAndLossList.vue?vue&type=style&index=0&id=1b293c1c&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__